export default __webpack_public_path__ + "static/media/google.7009e6d9.svg";